'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

function SecondaryTitle({ resourceKey, params }) {
  return h('h2.secondary-title', [
    h(
      Translate,
      {
        attrs: { class: 'secondary-title-text' },
        ...params,
      },
      resourceKey
    ),
  ]);
}

module.exports = SecondaryTitle;
